import React, { PropTypes } from 'react';

import { getAPIRoot } from '../../api/const';

import styled from 'styled-components';

const VehicleImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  img,
  figure {
    max-height: 150px;
    max-width: 100%;
  }
  ${props =>
    props.horizontal &&
    `
    width: ${props.horizontalImgWidthPercentage}%;
    margin: 0;
    img, figure{
      width: 100%;
    }`}
`;

const VehiclePlaceholder = styled.figure`
  width: 88px;
  height: 88px;
  background: url(${require('../../assets/images/placeholder-vehicle.png')});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
`;

const VehicleImage = ({
  imageKey,
  horizontal,
  horizontalImgWidthPercentage,
}) => {
  return (
    <VehicleImageContainer
      horizontal={horizontal}
      horizontalImgWidthPercentage={horizontalImgWidthPercentage}
    >
      {imageKey ? (
        <img src={`${getAPIRoot()}${imageKey}`} alt="vehicle" />
      ) : (
        <VehiclePlaceholder />
      )}
    </VehicleImageContainer>
  );
};

VehicleImage.defaultProps = {
  horizontalImgWidthPercentage: 50,
};

VehicleImage.propTypes = {
  imageKey: PropTypes.string,
  horizontal: PropTypes.bool,
  horizontalImgWidthPercentage: PropTypes.string,
};

export default VehicleImage;



// WEBPACK FOOTER //
// ./src/components/vehicle/VehicleImage.js